<div class="user-list-wrap">
  <div class="user-tabs">
    <a class="user-tab" routerLink="/user" routerLinkActive="user-tab-active" [routerLinkActiveOptions]="{exact: true}">User List</a>
    <a class="user-tab" routerLink="/user/add-new-user" routerLinkActive="user-tab-active">Add new user</a>
    <span class="user-tab user-tab-active" *ngIf="isEditMode">Update user detail</span>
  </div>

  <form #f="ngForm" (ngSubmit)="onSubmit()" class="add-user-form">
    <div class="left-panel">
      <img class="profile-avatar" [src]="profileImagePreview || defaultProfileImage" alt="Profile picture">

      <label class="file-upload-btn">
        File Upload
        <input type="file" accept=".jpg,.jpeg,.png" (change)="onProfileImageSelected($event)" hidden>
      </label>
      <p class="file-hint">Only .jpg .png .jpeg allowed</p>
    </div>

    <div class="right-panel">
      <div class="field-row">
        <div class="field-col">
          <label class="form-label">First Name<span class="mandatory">*</span>:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.firstName" name="firstName" [ngModelOptions]="{standalone: true}" placeholder="First Name">
        </div>
        <div class="field-col">
          <label class="form-label">Last Name<span class="mandatory">*</span>:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.lastName" name="lastName" [ngModelOptions]="{standalone: true}" placeholder="Last Name">
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Mobile Number<span class="mandatory">*</span>:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.mobileNo" name="mobileNo" [ngModelOptions]="{standalone: true}" placeholder="Mobile Number">
        </div>
        <div class="field-col">
          <label class="form-label">Email<span class="mandatory">*</span>:</label>
          <input type="email" class="form-control inputField" [(ngModel)]="user.email" name="email" [ngModelOptions]="{standalone: true}" placeholder="Email">
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Street Address 1:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.addressLine1" name="addressLine1" [ngModelOptions]="{standalone: true}" placeholder="Street Address 1">
        </div>
        <div class="field-col">
          <label class="form-label">Street Address 2:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.addressLine2" name="addressLine2" [ngModelOptions]="{standalone: true}" placeholder="Street Address 2">
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Country:</label>
          <select class="form-control inputField" [(ngModel)]="user.country" name="country" [ngModelOptions]="{standalone: true}" (change)="onCountryChange($event)">
            <option *ngFor="let option of countryOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="field-col">
          <label class="form-label">State<span class="mandatory">*</span>:</label>
          <select class="form-control inputField" [(ngModel)]="user.state" name="state" [ngModelOptions]="{standalone: true}" (change)="onStateChange($event)">
            <option value="" disabled selected>Choose State</option>
            <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
          </select>
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Town/City<span class="mandatory">*</span>:</label>
          <select class="form-control inputField" [(ngModel)]="user.city" name="city" [ngModelOptions]="{standalone: true}">
            <option value="" disabled selected>Choose City</option>
            <option *ngFor="let city of cities" [value]="city.name">{{ city.name }}</option>
          </select>
        </div>
        <div class="field-col">
          <label class="form-label">Pin Code<span class="mandatory">*</span>:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.zipCode" name="zipCode" [ngModelOptions]="{standalone: true}" placeholder="Pin Code">
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">User Role<span class="mandatory">*</span>:</label>
          <select class="form-control inputField" [(ngModel)]="user.userRole" name="userRole" [ngModelOptions]="{standalone: true}">
            <option value="" disabled selected>Choose Role</option>
            <option *ngFor="let role of userRoles" [value]="role">{{ role }}</option>
          </select>
        </div>
        <div class="field-col">
          <label class="form-label">User Gender<span class="mandatory">*</span>:</label>
          <select class="form-control inputField" [(ngModel)]="user.gender" name="gender" [ngModelOptions]="{standalone: true}">
            <option value="" disabled selected>Choose Gender</option>
            <option *ngFor="let gender of genders" [value]="gender">{{ gender }}</option>
          </select>
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Facebook Url:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.facebookUrl" name="facebookUrl" [ngModelOptions]="{standalone: true}" placeholder="Facebook Url">
        </div>
        <div class="field-col">
          <label class="form-label">Twitter Url:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.twitterUrl" name="twitterUrl" [ngModelOptions]="{standalone: true}" placeholder="Twitter Url">
        </div>
      </div>

      <div class="field-row">
        <div class="field-col">
          <label class="form-label">Instagram Url:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.instagramUrl" name="instagramUrl" [ngModelOptions]="{standalone: true}" placeholder="Instagram Url">
        </div>
        <div class="field-col">
          <label class="form-label">Linkedin Url:</label>
          <input type="text" class="form-control inputField" [(ngModel)]="user.linkdinUrl" name="linkdinUrl" [ngModelOptions]="{standalone: true}" placeholder="Linkedin Url">
        </div>
      </div>

      <button type="submit" class="btn applyBtn send-invite-btn" [disabled]="submitting || loadingUser">
        {{ isEditMode ? 'Update User Details' : 'Send Invite' }}
      </button>
    </div>
  </form>
</div>
